import VulnerStatistics from './vulner_statistics'
export default VulnerStatistics